<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Login with other user <div class="pull-right">
    <a class="boxclose" (click)="closeDialog()"></a>
  </div>
</h2>
<mat-dialog-content class="">
  <nb-card>
    <nb-card-body>
      <ng2-smart-table class="ng2-table" [settings]="settings" [source]="customerList"
        (custom)="onCustomAction($event)">
      </ng2-smart-table>
    </nb-card-body>
  </nb-card>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="closeDialog()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right"> Close </button>
</mat-dialog-actions>